<template>
  <div class="im-wrap" v-show="showIMStore">
    <div class="im-header">
      {{ headerUserRest.patientName }}
      <div class="close-img" @click="showImClear">
        <Icon type="md-close" />
      </div>
    </div>
    <div class="im-message" ref="messagebox">
      <Scroll :on-reach-top="handleReachTop" class="im-message-scroll-wrap">
        <!-- <p class="im-message-history" @click="handlerhistoryMsg">历史记录</p> -->
        <viewer class="seek-img-list" :images="imagesListSeek[itemkey]">
          <!-- {{messageArr[itemkey]}} -->
          <div
            v-for="(item, index) in messageArr[itemkey]"
            :key="index"
            :class="item.type == 1 ? 'im-type-box' : 'im-type-box im-type-box1'"
          >
            <div
              v-if="item.fromGuid == headerUserRest.xbkp_user"
              class="im-type-left"
            >
              <div class="avatar patientAvatar">患者</div>

              <div class="content">
                <!-- 查看图片 -->
                <p v-if="item.message.newype === 'pflink'">
                  <img
                    v-if="item.message.content"
                    :src="item.message.content"
                    @click="showImageHandler"
                  />
                </p>

                <p v-if="item.message.newype === 'txt'">
                  {{ item.message.content }}
                </p>

                <p
                  v-if="
                    item.message.newype === 'videolink' ||
                    item.message.newype === 'vflink' ||
                    item.message.newype === 'filelink'
                  "
                >
                  [请在手机APP医护助理端查看音频/视频/文件]
                </p>
              </div>
            </div>

            <div
              v-if="item.fromGuid == userInfo.xbkp_id"
              class="im-type-right content"
            >
              <div class="content">
                <!-- 查看图片 -->
                <p v-if="item.message.newype === 'pflink'">
                  <img
                    v-if="item.message.content"
                    :src="item.message.content"
                    @click="showImageHandler"
                  />
                </p>

                <!-- 查看文字 -->
                <p v-if="item.message.newype === 'txt'">
                  {{ item.message.content }}
                </p>

                <p v-if="item.message.newype === 'noticeCard'">
                  {{ JSON.parse(item.message.content).title }}
                </p>

                <!-- 取药方式 -->
                <div
                  v-if="item.message.newype === 'noticeFetchDrug'"
                  class="messageTakeDrug"
                >
                  <!-- <p v-html="item.message.content.notice"> -->
                  <p>
                    <span>就诊人：{{ item.message.content.info.name }} </span>
                  </p>
                  <p>
                    <span>年龄：{{ item.message.content.info.age }} </span
                    ><span>性别： {{ item.message.content.info.sex }} </span>
                  </p>
                  <p>
                    <span>接诊时间：{{ item.message.content.info.time }} </span>
                  </p>
                  <p class="messageTakeDrug-btn">
                    请点击此处<br />{{ item.message.subTitle }}
                  </p>
                </div>
              </div>
              <div class="avatar doctorAvatar">医生</div>
            </div>
          </div>
        </viewer>
      </Scroll>
    </div>
    <div class="fun-box">
      <p class="fun-list">
        <!-- @click="handlerSendImage" -->
        <span>
          <Upload
            :format="['jpg', 'png', 'jpeg']"
            name="fileFiled"
            :max-size="2048"
            action=""
            :on-success="handleReportUploadSuccess"
            :on-format-error="handleFormatError"
            :on-error="handleUploadError"
            :before-upload="handleBeforeUpload"
          >
            <img
              src="../../../../../static/image/icon-img.png"
              class="too-img"
              alt=""
            />
          </Upload>
        </span>
        <span
          @click="isRecordModelhandler"
          v-if="
            $store.state.prvateConsultation.headerUserRest.show_getDrug_type ==
              1 && $store.state.prvateConsultation.headerUserRest.status != 3
          "
        >
          <img
            src="../../../../../static/image/icon-drug-type.png"
            class="too-img"
            alt=""
          />
        </span>
      </p>
      <!-- <Icon type="md-image" size="30" style="cursor: pointer"/> -->
      <div @click="enterEvent">发送</div>
    </div>
    <div class="input-box">
      <textarea v-model="inputMessage" @keydown.enter="enterEvent" />
    </div>

    <recordModel
      :parameter="isRecordModel"
      v-on:handlermodalCancel="handlermodalCancel"
      v-on:handlermodalRecordList="handlermodalRecordList"
    ></recordModel>
  </div>
</template>

<script>
import { api } from '@/services'
import { mapGetters } from 'vuex'
import { fileToBase64 } from '@/utils'
// src/components/private_consultation_page/fun_right/diagnosisRecordList
import recordModel from '../diagnosisRecordList/index'

export default {
  components: { recordModel },
  props: {
    messgeRegistration: {
      type: String,
      default: ''
    },
    isSend: {
      type: Boolean,
      default: false
    },
    showIMStore: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      lockTimeLoad: true,
      // 查看大图时候  聊天消息发送了图片  暂存
      imagesListSeekD: [],
      typeImg: {
        'text': 1,
        'img': 2,
        'takeDrug': 3
      },
      isRecordModel: false,
      // 消息数组
      // type：1患者，2医生
      // mesageType：消息类型，1:文字，2:图片，3:其他
      inputMessage: '',
      // doctorUserId: this.$store.state.auth.info.userId,
      // showIMTime: {},
      // userInfoTakeDrug: {},
      // 用 双方的xbkpid作为key

      itemkey: '',
      //  定时刷新消息接口-参数
      getArchiveMsgParams: {
        historytime: new Date().getTime(),
        time: new Date().getTime() - 600000,
        history: 0
      },
      //  定时刷新消息接口-定时器
      intervalID: true

    }
  },
  created: function () {
    console.log(this.headerUserRest)
    //  this.showIMStoreTime()
  },
  mounted: function () {
  },
  watch: {
    messgeRegistration: function (val) {
      if (this.isSend) {
        this.inputMessage = val
        this.enterEvent(null, 'text')
      }
    },
    orderId: function (val) {
      console.log(val)
    },
    showIMStore: function (val) {
      if (!this.showIMStore) {
        this.showImClear()
        return false
      }
      this.intervalID = true
      // 用 双方的xbkpid作为key
      this.itemkey = this.userInfo.xbkp_id + 'taogu' + this.headerUserRest.xbkp_user
      if (!this.messageArr[this.itemkey]) {
        this.$store.commit('im/setMessage', {
          storeKey: this.itemkey,
          init: 0
        })
      }

      this.showIMStoreTime()
    },
    messageArr: {
      deep: true,
      handler (pre, next) {
        console.log(next)
        console.log('995489586958')
      },
      immediate: true

    }
  },
  computed: {
    ...mapGetters({
      headerUserRest: 'prvateConsultation/headerUserRest',
      showIM: 'prvateConsultation/showIM',
      messageArr: 'im/messageArr',
      imagesListSeek: 'im/imagesListSeek',
      userInfo: 'auth/info'
    }),
    orderId (val) {
      return this.$store.state.prvateConsultation.orderId
    }
  },
  methods: {
    // 关闭im对话窗
    showImClear () {
      this.intervalID = false
      this.$store.commit('prvateConsultation/showImBox', false)
    },
    // 查看大图时  定时器暂时清除
    showImageHandler () {
      // this.IsShowImagesList =  true
      // this.intervalID = false
    },
    // 取药方式 取消
    handlermodalCancel (isRecordModel) {
      this.isRecordModel = false
    },
    // 确定诊疗记录
    handlermodalRecordList (childValue) {
      this.inputMessage = childValue.orderId
      // this.userInfoTakeDrug = childValue.userInfoHtml
      this.enterEvent(childValue.e, childValue.type)
      this.isRecordModel = false
    },
    // 取药方式打开
    isRecordModelhandler () {
      this.isRecordModel = true
    },
    // 上传图片
    handleReportUploadSuccess (res, file) {
      // console.log(file)
    },
    handleFormatError (file) {
      this.$Notice.warning({
        title: '文件类型错误',
        desc: file.name + '仅支持jpg,png,jpeg格式的图片，大小不超过2M'
      })
    },
    handleUploadError (error) {
      this.$Message.error(error.commonMessage)
    },
    handleBeforeUpload (file) {
      if (file.type === 'image/png' || file.type === 'image/jpg' || 'image/jpeg') {
        fileToBase64(file).then(data => {
          this.uploadAvatar(file)
        })
        return false
      } else {
        this.$Notice.warning({
          title: '文件类型错误',
          desc: file.name + '仅支持jpg,png,jpeg格式的图片，大小不超过2M'
        })
        return false
      }
    },
    async uploadAvatar (file) {
      api.uploadFileChat({
        name: 'fileField',
        file: file
      })
        .then(res => {
          const url = res.fileFieldStorageFileName
          if (url) {
            this.inputMessage = url
            this.enterEvent(null, 'img')
          }
        })
    },

    nextOrderType (type) {
      // TODO::
      console.log(type)
    },
    enterEvent (e, type) {
      if (e) {
        e.preventDefault() // 取消默认回车换行事件
      }

      if (this.inputMessage === '') return

      // var doctorIM = []

      // var type = (type || 'text')

      api
        .sendMsg({
          data: {
            params: {
              context: this.inputMessage,
              userId: this.headerUserRest.userId,
              type: type || 'text'
            }
          }
        })
        .then(res => {
          if (res.code === 0) {
            this.$Message.success('消息发送成功')
            this.inputMessage = ''
          }
        })
    },
    // 请求发送消息的接口
    async handlerGetOfflineMsg (time, history) {
      this.lockTimeLoad = false
      await api.getArchiveMsg({
        data: {
          params: {
            // 时间戳
            time: time || this.getArchiveMsgParams.time,
            history: history || this.getArchiveMsgParams.history,
            toUserType: 2,
            toUserGuid: this.headerUserRest.xbkp_user
          }
        }
      })
        .then(res => {
          this.lockTimeLoad = true
          for (const key in res) {
            if (typeof res[key] === 'object') {
              res[key].storeKey = this.itemkey
              res[key].history = (history || this.getArchiveMsgParams.history)

              if (history === 1) {
                this.getArchiveMsgParams.historytime = res[key].time
              } else {
                this.getArchiveMsgParams.time = res[key].time
              }
              if (res[key].message.newype === 'txt') {
                try {
                  res[key].message.content = JSON.parse(res[key].message.content).title || res[key].message.content
                } catch (error) {
                }
              }
              if (res[key].message.newype === 'noticeFetchDrug') {
                res[key].message.content = JSON.parse(res[key].message.content)
              }
              // 如果是图片 需要图片放大
              if (res[key].message.newype === 'pflink') {
                this.$store.commit('im/setLmagesList', res[key])
                // this.imagesListSeek.push(res[key].message.content.icon)
              }
              // 信息存储到vuex
              this.$store.commit('im/setMessage', res[key])
              //  console.log(res[key])
            }
          }

          if (!res[0]) {
            return false
          }
          this.$nextTick(() => {
            this.$forceUpdate()

            // console.log(this.messageArr[this.itemkey])
            // DOM 更新循环结束之后执行延迟,将滚动条调到最底部
            let dom = document.getElementsByClassName('im-message')[0]
            if (history === 1) {
              dom.scrollTop = 0
            } else {
              dom.scrollTop = dom.scrollHeight
            }
          })
        })
    },
    // 去请求之前的消息记录

    handleReachTop () {
      this.handlerGetOfflineMsg(this.getArchiveMsgParams.historytime, 1)
    },
    // 去请求之前的消息记录
    // handlerhistoryMsg(){
    //   this.handlerGetOfflineMsg(this.getArchiveMsgParams.historytime,1)
    // },

    showIMStoreTime () {
      let _that = this
      // this.intervalID
      setInterval(function () {
        if (!_that.intervalID) {
          return false
        }
        if (_that.lockTimeLoad) {
          _that.showIMStoreTime()
          _that.handlerGetOfflineMsg()
        }
      }, 1000 * 3)
    }

  }
}

</script>

<style lang="scss">
.im-wrap {
  width: 195px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 12px;
  box-shadow: 0px 2px 5px 0px rgba(191, 191, 191, 0.75);
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  z-index: 10;
}
.im-header {
  height: 28px;
  background: #ebebeb;
  text-align: center;
  line-height: 28px;
  position: relative;
  color: #000;
}
.close-img {
  position: absolute;
  top: 0px;
  right: 3px;
  cursor: pointer;
}
.im-message {
  flex: 1;
  height: 250px;
  overflow-y: scroll;
  padding: 4px;
  box-sizing: border-box;
}
.fun-box {
  height: 28px;
  background: #ebebeb;
  padding: 4px 6px;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 9px;
}
.fun-box > div {
  cursor: pointer;
  width: 40px;
  height: 20px;
  background: #72beff;
  border-radius: 3px;
  line-height: 20px;
  color: #fff;
  text-align: center;
}
.input-box {
  height: 4rem;
  padding: 4px;
  box-sizing: border-box;
}
.input-box > textarea {
  width: 100%;
  height: 100%;
  border: none;
  resize: none;
  font-size: 9px;
  color: #000;
}
.input-box > textarea:focus {
  border: none;
  outline: none;
}
.im-type-box {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  font-size: 9px;
  line-height: 12px;
  margin-bottom: 5px;
}
.im-type-box1 {
  justify-content: flex-end;
}
.im-type-left {
  width: 98%;
  display: flex;
  justify-content: flex-start;
}
.im-type-right {
  width: 85%;
  display: flex;
  justify-content: flex-end;
}
.im-type-left .avatar,
.im-type-right .avatar {
  width: 25px;
  height: 25px;
  display: block;
  flex: 0 0 auto;
  line-height: 25px;
  text-align: center;
  margin-right: 2px;
  text-indent: 999px;
  overflow: hidden;
}
.avatar.patientAvatar {
  background: url('~@/assets/images/patient60.png') center no-repeat;
  background-size: cover;
}
.avatar.doctorAvatar {
  background: url('~@/assets/images/doctor60.png') center no-repeat;
  background-size: cover;
}
.im-type-right .avatar {
  margin-left: 2px;
}
.im-type-left .content,
.im-type-right .content {
  padding: 4px;
  display: inline-block;
  word-wrap: break-word;
  word-break: break-all;
  border-radius: 3px;
  background: #ebebeb;
}
.im-type-right .content {
  background: #daecfb;
  /* width: 90%; */
}
.im-type-right .content img {
  width: 100%;
}
.notice img {
  width: 20px;
  border-right: 1px solid #ccc;
  vertical-align: middle;
  margin-right: 5px;
  padding-right: 5px;
}
.fun-list {
  text-align: left;
  width: 100%;
}
.fun-list span {
  cursor: pointer;
}

.messageTakeDrug p {
  line-height: 0.6rem;
}
.messageTakeDrug p span {
  margin-right: 0.2rem;
}
.messageTakeDrug-btn {
  text-align: center;
}
.ivu-upload {
  display: inline-block;
}
/* .im-type-right .content{
  width: 100%;
} */
.im-type-right .content img {
  width: 100%;
}
.seek-img-list {
  width: auto;
  min-width: initial;
  overflow: hidden;
  height: auto;
}
.too-img {
  width: 0.5rem;
  vertical-align: middle;
}
.fun-list span {
  vertical-align: middle;
  height: 0.5rem;
  display: inline-block;
  margin-left: 0.1rem;
}
.seek-img-list {
  display: block !important;
}
.im-message-history {
  text-align: center;
  line-height: 0.8rem;
  color: #72beff;
}
.im-message-scroll-wrap {
  box-sizing: border-box;
  .ivu-scroll-container {
    overflow-y: auto;
    height: calc(100vh - 11rem) !important;
    .ivu-scroll-loader:first-child {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/private_consultation_page/fun_right/im_page/index.vue